module.exports = __webpack_public_path__ + "static/media/policy-search-header.20bffcd2.png";